import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit {
  PaymentModel={
    PGOrderNo:"",
    OrderNo:"",
    PaidAmount:0,
    CreditAmount:0,
    CurrencyCode:"",
    Key:"",
    Email:"",
    Mobile:'',
    CustomerName:"",
    CustomerID:0,
    RefernceNo:"",
    Signature:"",
    ReceiptNo:"",
    CurrencyRate:""
  };
  constructor() { 
    
    
  }

  ngOnInit() {

    this.PaymentModel.ReceiptNo= window.localStorage.getItem("ReceiptNo");
    this.PaymentModel.RefernceNo=window.localStorage.getItem("razorpay_payment_id");
    
    
     
  
  }

  
GetReceipt()
{
 return window.localStorage.getItem("ReceiptNo")==null?'': window.localStorage.getItem("ReceiptNo");
}
}
